"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Product = void 0;
var Product;
(function (Product) {
    Product["CreditCard"] = "credit_card";
    Product["Loan"] = "loan";
    Product["Mortgage"] = "mortgage";
    Product["Deposits"] = "deposits";
    Product["LifeInsurance"] = "life_insurance";
    Product["Other"] = "other";
})(Product = exports.Product || (exports.Product = {}));
//# sourceMappingURL=productsKeys.js.map